import { createContext, useContext } from 'react'

export interface ProfileCompletionCtxValue {
  isComplete: boolean
  refresh: () => void
}

export const ProfileCompletionCtx = createContext<ProfileCompletionCtxValue>({
  isComplete: true,
  refresh: () => {},
})

export function useProfileCompletion() {
  return useContext(ProfileCompletionCtx)
}

export function checkProfileComplete(data: Record<string, unknown>): boolean {
  return !!(
    (data?.full_name as string)?.trim() &&
    (data?.phone as string)?.trim() &&
    (data?.experience_level as string)?.trim() &&
    (data?.target_role as string)?.trim() &&
    (data?.language as string)?.trim() &&
    (data?.timezone as string)?.trim()
  )
}
